import { useState } from "react";
import SearchVisitRequestCard from "../../components/card/SearchVisitRequestCard";
import SearchPassTable from "../../components/table/SearchPassTable";
import Loader from "../../components/loader";
import { PAGE_SIZE, TABLE_IDS, USER_ROLES_IDS } from "../../constants/common";
import { Button } from "../../components/button";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../../routes";
import useAuthStore from "../../store/Auth";
import BackButton from "../../components/button/BackButton";
import { ExportApprovedVisitRequestsForExcelPDFBody } from "../../hooks/visitor/interface";
import { useTranslation } from "react-i18next";

const SearchVisitRequest = () => {
  const [exportBody, setExportBody] =
    useState<ExportApprovedVisitRequestsForExcelPDFBody>();
  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState<number>(PAGE_SIZE);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  const navigate = useNavigate();

  const user = useAuthStore((state) => state.user);

  const [allVisitorAppointments, setAllVisitorAppointments] = useState([]);

  return (
    <div className="flex flex-col gap-4 md:gap-8">
      <div className="flex items-center gap-1 sm:gap-2 justify-between">
        <h1 className="text-xl md:text-2xl dark:text-white">
          {t("searchVisitRequest")}
        </h1>

        {user?.n_RoleID !== USER_ROLES_IDS.CYBER_SECURITY &&
          user?.n_RoleID !== USER_ROLES_IDS.SECURITY_MANAGER && (
            <div className="flex items-center gap-2">
              <Button
                type="button"
                onClick={() => navigate(APP_ROUTES.CREATE_VISIT_REQUEST)}
                className="bg-transparent ring-1 ring-purple-primary text-purple-primary hover:bg-transparent dark:!ring-white dark:text-white"
              >
                {t("createVisitRequest")}
              </Button>
              <BackButton />
            </div>
          )}

        {(user?.n_RoleID === USER_ROLES_IDS.CYBER_SECURITY ||
          user?.n_RoleID === USER_ROLES_IDS.SECURITY_MANAGER) && <BackButton />}
      </div>

      <SearchVisitRequestCard
        isVisitReqType={false}
        setIsLoading={setIsLoading}
        page={page}
        setPages={setPages}
        search={search}
        setCount={setCount}
        setAllVisitorAppointments={setAllVisitorAppointments}
        setExportBody={setExportBody}
        pageSize={pageSize}
      />

      {isLoading && (
        <div className="flex justify-center">
          <Loader />
        </div>
      )}
      
      <SearchPassTable
        allVisitorAppointments={allVisitorAppointments}
        page={page}
        pages={pages}
        setPage={setPage}
        count={count}
        search={search}
        setSearch={setSearch}
        tableId={TABLE_IDS.SEARCH_VISIT_REQUEST}
        exportBody={exportBody}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </div>
  );
};

export default SearchVisitRequest;
